var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDotLayer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 141.5,
    height: 94.333,
    viewBox: "0 0 141.5 94.333",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2396",
    "data-name": "\\uADF8\\uB8F9 2396",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3696",
    "data-name": "\\uD328\\uC2A4 3696",
    d: "M416.884,163.142a2.942,2.942,0,1,1-2.942-2.942A2.994,2.994,0,0,1,416.884,163.142Z",
    transform: "translate(-411 -160.2)",
    fill: "#c6b9b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3697",
    "data-name": "\\uD328\\uC2A4 3697",
    d: "M443.784,163.142a2.942,2.942,0,1,1-2.942-2.942A3.076,3.076,0,0,1,443.784,163.142Z",
    transform: "translate(-369.966 -160.2)",
    fill: "#c6b9b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3698",
    "data-name": "\\uD328\\uC2A4 3698",
    d: "M470.584,163.142a2.942,2.942,0,1,1-2.942-2.942A2.994,2.994,0,0,1,470.584,163.142Z",
    transform: "translate(-329.084 -160.2)",
    fill: "#c6b9b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3699",
    "data-name": "\\uD328\\uC2A4 3699",
    d: "M416.884,182.942A2.942,2.942,0,1,1,413.942,180,2.921,2.921,0,0,1,416.884,182.942Z",
    transform: "translate(-411 -135.775)",
    fill: "#c6b9b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3700",
    "data-name": "\\uD328\\uC2A4 3700",
    d: "M443.784,182.942A2.942,2.942,0,1,1,440.842,180,3,3,0,0,1,443.784,182.942Z",
    transform: "translate(-369.966 -135.775)",
    fill: "#c6b9b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3701",
    "data-name": "\\uD328\\uC2A4 3701",
    d: "M470.584,182.942A2.942,2.942,0,1,1,467.642,180,2.921,2.921,0,0,1,470.584,182.942Z",
    transform: "translate(-329.084 -135.775)",
    fill: "#c6b9b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3702",
    "data-name": "\\uD328\\uC2A4 3702",
    d: "M416.884,202.742a2.942,2.942,0,1,1-5.884,0,2.854,2.854,0,0,1,2.942-2.942A2.921,2.921,0,0,1,416.884,202.742Z",
    transform: "translate(-411 -111.351)",
    fill: "#c6b9b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3703",
    "data-name": "\\uD328\\uC2A4 3703",
    d: "M443.784,202.742a2.942,2.942,0,0,1-5.884,0,2.854,2.854,0,0,1,2.942-2.942A3,3,0,0,1,443.784,202.742Z",
    transform: "translate(-369.966 -111.351)",
    fill: "#c6b9b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3704",
    "data-name": "\\uD328\\uC2A4 3704",
    d: "M470.584,202.742a2.942,2.942,0,1,1-5.884,0,2.854,2.854,0,0,1,2.942-2.942A2.921,2.921,0,0,1,470.584,202.742Z",
    transform: "translate(-329.084 -111.351)",
    fill: "#c6b9b6"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotLayer);
export default __webpack_public_path__ + "static/media/dot_layer.fa39e5ee276ad6e6a0a969bdbd6017a0.svg";
export { ForwardRef as ReactComponent };